<template>
  <div>
    <div class="content">
        <router-link
          class="content__logo"
          tag="figure"
          to="/game"
        >
          <img
            src="@/assets/logo.png"
            alt="logo"
          />
        </router-link>

        <transition name="fade" appear mode="out-in">
          <h2 class="content__title">
            TICKET
          </h2>
        </transition>
      </div>
    <div class="code-wrapper">
      <div class="ticket-code" v-if="code">

        <span v-for="(char, key) in code" :key="key">
          {{char}}
        </span>
      </div>
      <div class="ticket-code" v-else-if="generatedCode">

        <span v-for="(char, key) in generatedCode" :key="key">
          {{char}}
        </span>
      </div>
    </div>
    <product :eanupc="ean" :vendingFeatures="false"/>
    <div class="footer">
      <touch-ripple :speed="1" :opacity="0.3" color="#eee" transition="ease" @click="dispense" v-if="voucher && !voucher.dispensed">
        <button class="button" type="submit" @click.prevent="dispense">{{$t('dispense')}}</button>
      </touch-ripple>
      <button v-else-if="voucher" class="button out-of-stock">{{voucher.dispensed | toDate}}</button>
    </div>
  </div>
</template>

<script>
import Product from '@/components/views/Product'
import moment from 'moment'

export default {
  props: {
    ean: {
      type: String,
      default: null
    },
    code: {
      type: String,
      default: null
    }
  },
  components: {
    Product
  },
  methods: {
    dispense () {
      this.$api.dispenseVoucher(this.code).then(resp => {
        this.voucher = resp.data.result
        console.log(resp)
      }).catch(err => {
        console.log(err)
      })
    }
  },
  data () {
    return {
      generatedCode: null,
      voucher: null
    }
  },
  filters: {
    toDate (date) {
      return moment(date).format('MM/DD/YYYY - HH:mm')
    }
  },
  mounted () {
    if (this.code === null) {
      this.$api.dispense(this.ean).then(response => {
        this.generatedCode = response.data.result[0].voucher
      }).catch(err => {
        console.log(err)
      })
    } else {
      this.$api.voucher(this.code).then(response => {
        this.voucher = response.data.result
      })
    }
    if (!this.$store.state.Products.products.length) {
      this.$router.push('/products')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/style/css/screens.scss';
.code-wrapper {
  width: 100%;
  display: flex;
  justify-content: center;
  .ticket-code {
    width: 60%;
    display: flex;
    justify-content: space-between;
    span {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 50px;
      height: 50px;
      font-size: 30px;
      font-weight: bold;
      border-radius: 5px;
      border-style: solid;
      border-width: 3px;
      border-color: black;
      @media screen and (max-width: $handheld) {
        margin-bottom: 2%;
        margin-top: 2%;
      }
      @media screen and (orientation: landscape) and (max-height: $handheld) {
        width: 30px;
        height: 30px;
        font-size: 16px;
      }
    }
    @media screen and (max-width: $handheld) {
      margin-bottom: 2%;
      margin-top: 2%;
    }
    @media screen and (orientation: landscape) and (max-height: $handheld) {
      width: 30%;
    }
  }
}

.content {
  grid-area: content;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2%;
  margin-top: 2%;
  @media screen and (max-width: $handheld) {
    margin-bottom: 2%;
    margin-top: 2%;
  }
  @media screen and (orientation: landscape) and (max-height: $handheld) {
    margin-bottom: 2%;
    margin-top: 2%;
  }

  &__logo {
    max-width: 350px;
    margin-bottom: 20px;

      @media screen and (max-width: $handheld) {
        max-width: 220px;
      }
      @media screen and (orientation: landscape) and (max-height: $handheld) {
        margin-bottom: 0;
        width: 25%;
      }

    & > img {
      object-fit: contain;
      max-width: inherit;
    }
  }

  &__title {
    font-size: 2rem;
    text-transform: uppercase;
    text-align: center;

    @media screen and (max-width: $handheld) {
      font-size: 1.2rem;
    }

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      font-size: 1.2rem;
    }
  }
}

.footer {
  position: fixed;
  display: flex;
  justify-content: center;
  transform: translateY(0%);
  width: 100%;
  margin-bottom: 10vh;

  @media screen and (max-width: $handheld) {
   margin-bottom: 15vh;
  }

  @media screen and (orientation: landscape) and (max-height: $handheld) {
   margin-bottom: 10vh;
  }

  @media screen and (max-width: $tablet) {
   margin-bottom: 15vh;
  }

  @media screen and (orientation: landscape) and (max-height: $tablet) {
   margin-bottom: 10vh;
  }

  bottom:0;

  .button {
    font-size: 24px;
    font-family: 'Gotham';
    text-transform: uppercase;
    letter-spacing: 1px;
    margin-bottom: 0;
    @media screen and (max-width: $handheld) {
      font-size: 17px;
    }

    @media screen and (orientation: landscape) and (max-height: $handheld) {
      font-size: 17px;
    }
    &.out-of-stock {
      background: white;
      color: black;
    }
  }
}
</style>
